import ReactGA4 from "react-ga4";

const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';

const InitializeGoogleAnalytics = (MEASUREMENT_ID) => {
    if (!MEASUREMENT_ID || !isProduction) {
        console.log(`GA: Initialization skipped (production: ${isProduction}, MEASUREMENT_ID: ${!!MEASUREMENT_ID})`);
        return;
    }
    try {
        ReactGA4.initialize(MEASUREMENT_ID, {
            gaOptions: {
                cookieFlags: "SameSite=None;Secure"
            },
        });
        console.log("GA INITIALIZED");
    } catch (e) {
        console.log("GA INITIALIZATION ERROR:", e.message);
    }
};

const TrackGoogleAnalyticsEvent = (
    category = "",
    action = "",
    label = ""
) => {
    if (!isProduction) {
        console.log("GA event (dev only):", category, ":", action, ":", label);
        return;
    }
    console.log("GA event:", category, ":", action, ":", label);
    try {
        ReactGA4.event({
            category: category,
            action: action,
            label: label,
        });
    } catch (e) {
        console.log("GA event error:", e.message)
    }
};

export default InitializeGoogleAnalytics;
export { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent };